import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {DocketPrintingRuleSearchModel} from "../docket-printing-rule-search-model.service";
import {DocketPrintingRuleEntityModel} from "../docket-printing-rule-entity-model.service";

@Component({
    selector: "wbo-docket-printing-rule-search-page",
    templateUrl: "./docket-printing-rule-search-page.component.html",
    providers: [
        provideSearchModel(DocketPrintingRuleSearchModel),
        provideEntityModel(DocketPrintingRuleEntityModel)
    ]
})
export class DocketPrintingRuleSearchPageComponent extends AbstractSearchPage {
}
